/**
 * Демонун базарлары — ар өлкөгө бир жазуу.
 *
 * Эмне үчүн мындай: мурда ар өлкөнүн тексти коддун ичинде
 * `isMn ? 'монголчо' : 'орусча'` түрүндө чачылып турган — 4 файлда ~60 жер.
 * Эки базарда эле чаташа баштаган (кыргыз шилтемеси монгол бетине чыгып
 * кеткен). Жаңы өлкө кошуу эми ушул жерге бир жазуу кошуу дегенди
 * билдирет — компоненттерге тийилбейт.
 *
 * Маалымат (китептер, главалар, сегменттер) `data/<код>.js`те, ал
 * `scripts/demo-export.mjs` менен чыныгы системадан чыгарылат жана
 * керек болгондо гана жүктөлөт: 100 өлкөнүн демосу ар бир кардарга
 * жетпейт.
 *
 * ⚠️ Тексттерди ошол тилди эне тили катары билген адам окуп чыгышы керек:
 * сатуу бети — биринчи таасир. Жаңы базар кошулганда да ушундай.
 *
 * URL: `/login?market=ge`. Параметр жок болсо — `DEFAULT_MARKET`.
 */

const RU = {
  badge: 'Многоэтапный литературный ИИ-перевод',
  headline: 'Превратите рукописи в готовые книги на любом языке',
  subline: 'Полный цикл издательской подготовки: от распознавания сканированных PDF до четырёхэтапной редактуры с сохранением авторского стиля и единой терминологии.',
  tagline: 'Перевод, редактура и корректура книг',
  cta: 'Открыть демо-студию',
  ctaNote: 'Без регистрации — открывается сразу',
  books: (n) => `${n} ${ruPlural(n, ['книга', 'книги', 'книг'])}`,
  sampleTitle: 'Пример фрагмента',
  sampleBadge: 'Этап 4: проверено',
  original: 'Оригинал',
  translation: 'Перевод',
  chapter: 'Глава',
  features: ['Проверка качества книги', 'Глоссарий имён и терминов', 'Экспорт в DOCX и PDF'],
  banner: 'Демо-режим: образцы книг, первая глава которых переведена ИИ по-настоящему.',
  bannerCta: 'Купить полную версию',
  demoUser: 'Демо-гость',
  upgrade: {
    title: 'Лицензия FolioFlow Pro',
    headline: 'Переводите целые книги без ограничений',
    sub: 'В демо — первая глава. С полной лицензией: вся книга любого объёма, файлы PDF и DOCX до 300 МБ и общий доступ для команды.',
    listTitle: 'Что входит в полную лицензию:',
    features: [
      'Перевод книг любого объёма (1 500+ страниц)',
      'Четыре этапа: перевод, редактура, корректура, проверка',
      'Распознавание сканированных PDF (OCR)',
      'Глоссарий имён и терминов на всю книгу',
      'Установка на ваш сервер или в закрытое облако',
      'Ваши рукописи не используются для обучения моделей',
    ],
    contactTitle: 'Свяжитесь с нами — подключим и покажем:',
    back: 'Вернуться в демо-студию',
  },
};

export const MARKETS = {
  kg: { code: 'kg', flag: '🇰🇬', country: 'Кыргызстан', lang: 'ky', text: RU },
  ru: { code: 'ru', flag: '🇷🇺', country: 'Россия', lang: 'ru', text: RU },

  mn: {
    code: 'mn', flag: '🇲🇳', country: 'Монгол', lang: 'mn',
    text: {
      badge: 'Олон шатлалт уран зохиолын ИИ-орчуулга',
      headline: 'Дэлхийн ном зохиолыг монгол хэл рүү хэвлэлд бэлэн болгон хөрвүүлнэ',
      subline: 'Хэвлэлийн бүрэн бэлтгэл: сканнердсан PDF-ээс эхлээд зохиогчийн хэв маяг, нэр томьёог хадгалсан 4 үе шаттай орчуулгын студи.',
      tagline: 'Хэвлэлийн ИИ-орчуулгын студи',
      cta: 'Монгол демо-студи нээх',
      ctaNote: 'Бүртгэлгүйгээр, шууд нээгдэнэ',
      books: (n) => `${n} ном`,
      sampleTitle: 'Хэсгийн жишээ',
      sampleBadge: 'Үе шат 4: Хянагдсан',
      original: 'Эх',
      translation: 'Орчуулга',
      chapter: 'Бүлэг',
      features: ['Номын чанарын хяналт', 'Нэр, нэр томьёоны толь', 'DOCX болон PDF экспорт'],
      banner: 'Демо горим: эхний бүлгийг нь ИИ-ээр бодитоор орчуулсан номын загварууд.',
      bannerCta: 'Бүрэн лиценз авах',
      demoUser: 'Демо зочин',
      upgrade: {
        title: 'FolioFlow Pro лиценз',
        headline: 'Бүтэн номыг ямар ч хязгааргүйгээр орчуулах',
        sub: 'Демо нь эхний бүлгийг харуулна. Бүрэн лицензээр: ямар ч хэмжээтэй бүтэн ном, 300 МБ хүртэлх PDF/DOCX, багийн хамтын ажиллагаа.',
        listTitle: 'Бүрэн лицензийн давуу талууд:',
        features: [
          'Хүссэн хэмжээтэй бүтэн ном (1 500+ хуудас)',
          'Дөрвөн үе шат: орчуулга, редакц, корректур, хяналт',
          'Сканнердсан PDF файлыг таних (OCR)',
          'Бүтэн номын нэр, нэр томьёоны толь',
          'Танай сервер дээр эсвэл хаалттай үүлэнд суурилуулах',
          'Танай бүтээлийг загвар сургахад ашиглахгүй',
        ],
        contactTitle: 'Бидэнтэй холбогдож системээ суурилуулаарай:',
        back: 'Демо студи рүү буцах',
      },
    },
  },

  kz: {
    code: 'kz', flag: '🇰🇿', country: 'Қазақстан', lang: 'kk',
    text: {
      badge: 'Көпкезеңді әдеби ЖИ-аударма',
      headline: 'Қолжазбаларды кез келген тілдегі дайын кітапқа айналдырыңыз',
      subline: 'Баспаға толық дайындық: сканерленген PDF-ті танудан бастап автор стилі мен бірыңғай терминологияны сақтайтын төрт кезеңді редакцияға дейін.',
      tagline: 'Кітаптарды аудару, өңдеу және түзету',
      cta: 'Демо-студияны ашу',
      ctaNote: 'Тіркелусіз — бірден ашылады',
      books: (n) => `${n} кітап`,
      sampleTitle: 'Үзінді үлгісі',
      sampleBadge: '4-кезең: тексерілді',
      original: 'Түпнұсқа',
      translation: 'Аударма',
      chapter: 'Тарау',
      features: ['Кітап сапасын тексеру', 'Есімдер мен терминдер глоссарийі', 'DOCX және PDF экспорты'],
      banner: 'Демо-режим: бірінші тарауы ЖИ арқылы шынымен аударылған кітап үлгілері.',
      bannerCta: 'Толық нұсқаны сатып алу',
      demoUser: 'Демо-қонақ',
      upgrade: {
        title: 'FolioFlow Pro лицензиясы',
        headline: 'Кітаптарды шектеусіз толық аударыңыз',
        sub: 'Демода — бірінші тарау. Толық лицензиямен: кез келген көлемдегі бүкіл кітап, 300 МБ-қа дейінгі PDF және DOCX, команда үшін ортақ қолжетімділік.',
        listTitle: 'Толық лицензияға не кіреді:',
        features: [
          'Кез келген көлемдегі кітаптарды аудару (1 500+ бет)',
          'Төрт кезең: аударма, редакция, түзету, тексеру',
          'Сканерленген PDF-ті тану (OCR)',
          'Бүкіл кітапқа арналған есімдер мен терминдер глоссарийі',
          'Өз серверіңізге немесе жабық бұлтқа орнату',
          'Қолжазбаларыңыз модельдерді оқытуға пайдаланылмайды',
        ],
        contactTitle: 'Бізбен байланысыңыз — қосамыз және көрсетеміз:',
        back: 'Демо-студияға оралу',
      },
    },
  },

  uz: {
    code: 'uz', flag: '🇺🇿', country: 'Oʻzbekiston', lang: 'uz',
    text: {
      badge: 'Koʻp bosqichli badiiy sunʼiy intellekt tarjimasi',
      headline: 'Qoʻlyozmalarni istalgan tildagi tayyor kitoblarga aylantiring',
      subline: 'Nashrga toʻliq tayyorlash: skanerlangan PDF fayllarni tanishdan tortib, muallif uslubi va yagona atamalarni saqlagan holda toʻrt bosqichli tahrirgacha.',
      tagline: 'Kitoblarni tarjima qilish, tahrirlash va korrekturasi',
      cta: 'Demo-studiyani ochish',
      ctaNote: 'Roʻyxatdan oʻtmasdan — darhol ochiladi',
      books: (n) => `${n} ta kitob`,
      sampleTitle: 'Parcha namunasi',
      sampleBadge: '4-bosqich: tekshirildi',
      original: 'Asl matn',
      translation: 'Tarjima',
      chapter: 'Bob',
      features: ['Kitob sifatini tekshirish', 'Ismlar va atamalar lugʻati', 'DOCX va PDF eksporti'],
      banner: 'Demo rejimi: birinchi bobi sunʼiy intellekt yordamida haqiqatan tarjima qilingan kitob namunalari.',
      bannerCta: 'Toʻliq versiyani sotib olish',
      demoUser: 'Demo mehmon',
      upgrade: {
        title: 'FolioFlow Pro litsenziyasi',
        headline: 'Kitoblarni cheklovsiz toʻliq tarjima qiling',
        sub: 'Demoda — birinchi bob. Toʻliq litsenziya bilan: istalgan hajmdagi butun kitob, 300 MB gacha PDF va DOCX, jamoa uchun umumiy kirish.',
        listTitle: 'Toʻliq litsenziyaga nimalar kiradi:',
        features: [
          'Istalgan hajmdagi kitoblarni tarjima qilish (1 500+ sahifa)',
          'Toʻrt bosqich: tarjima, tahrir, korrektura, tekshiruv',
          'Skanerlangan PDF fayllarni tanish (OCR)',
          'Butun kitob uchun ismlar va atamalar lugʻati',
          'Oʻz serveringizga yoki yopiq bulutga oʻrnatish',
          'Qoʻlyozmalaringiz modellarni oʻqitish uchun ishlatilmaydi',
        ],
        contactTitle: 'Biz bilan bogʻlaning — ulab, koʻrsatib beramiz:',
        back: 'Demo-studiyaga qaytish',
      },
    },
  },

  az: {
    code: 'az', flag: '🇦🇿', country: 'Azərbaycan', lang: 'az',
    text: {
      badge: 'Çoxmərhələli bədii süni intellekt tərcüməsi',
      headline: 'Əlyazmaları istənilən dildə hazır kitablara çevirin',
      subline: 'Nəşrə tam hazırlıq: skan edilmiş PDF-lərin tanınmasından müəllif üslubu və vahid terminologiya qorunmaqla dörd mərhələli redaktəyə qədər.',
      tagline: 'Kitabların tərcüməsi, redaktəsi və korrekturası',
      cta: 'Demo-studiyanı açın',
      ctaNote: 'Qeydiyyatsız — dərhal açılır',
      books: (n) => `${n} kitab`,
      sampleTitle: 'Fraqment nümunəsi',
      sampleBadge: '4-cü mərhələ: yoxlanılıb',
      original: 'Orijinal',
      translation: 'Tərcümə',
      chapter: 'Fəsil',
      features: ['Kitab keyfiyyətinin yoxlanılması', 'Adlar və terminlər lüğəti', 'DOCX və PDF ixracı'],
      banner: 'Demo rejimi: birinci fəsli süni intellektlə həqiqətən tərcümə edilmiş kitab nümunələri.',
      bannerCta: 'Tam versiyanı alın',
      demoUser: 'Demo qonaq',
      upgrade: {
        title: 'FolioFlow Pro lisenziyası',
        headline: 'Kitabları məhdudiyyətsiz tam tərcümə edin',
        sub: 'Demoda — birinci fəsil. Tam lisenziya ilə: istənilən həcmdə bütün kitab, 300 MB-a qədər PDF və DOCX, komanda üçün ümumi giriş.',
        listTitle: 'Tam lisenziyaya nələr daxildir:',
        features: [
          'İstənilən həcmdə kitabların tərcüməsi (1 500+ səhifə)',
          'Dörd mərhələ: tərcümə, redaktə, korrektura, yoxlama',
          'Skan edilmiş PDF-lərin tanınması (OCR)',
          'Bütün kitab üçün adlar və terminlər lüğəti',
          'Öz serverinizə və ya qapalı buluda quraşdırma',
          'Əlyazmalarınız modellərin öyrədilməsi üçün istifadə olunmur',
        ],
        contactTitle: 'Bizimlə əlaqə saxlayın — qoşub göstərək:',
        back: 'Demo-studiyaya qayıt',
      },
    },
  },

  ge: {
    code: 'ge', flag: '🇬🇪', country: 'საქართველო', lang: 'ka',
    text: {
      badge: 'მრავალეტაპიანი ლიტერატურული AI თარგმანი',
      headline: 'აქციეთ ხელნაწერები მზა წიგნებად ნებისმიერ ენაზე',
      subline: 'სრული საგამომცემლო მომზადება: დასკანერებული PDF-ის ამოცნობიდან ოთხეტაპიან რედაქტირებამდე, ავტორის სტილისა და ერთიანი ტერმინოლოგიის შენარჩუნებით.',
      tagline: 'წიგნების თარგმანი, რედაქტირება და კორექტურა',
      cta: 'დემო-სტუდიის გახსნა',
      ctaNote: 'რეგისტრაციის გარეშე — მაშინვე იხსნება',
      books: (n) => `${n} წიგნი`,
      sampleTitle: 'ფრაგმენტის ნიმუში',
      sampleBadge: 'ეტაპი 4: შემოწმებულია',
      original: 'ორიგინალი',
      translation: 'თარგმანი',
      chapter: 'თავი',
      features: ['წიგნის ხარისხის შემოწმება', 'სახელებისა და ტერმინების ლექსიკონი', 'ექსპორტი DOCX-სა და PDF-ში'],
      banner: 'დემო რეჟიმი: წიგნების ნიმუშები, რომელთა პირველი თავი რეალურად არის თარგმნილი AI-ით.',
      bannerCta: 'სრული ვერსიის შეძენა',
      demoUser: 'დემო სტუმარი',
      upgrade: {
        title: 'FolioFlow Pro ლიცენზია',
        headline: 'თარგმნეთ წიგნები სრულად, შეზღუდვების გარეშე',
        sub: 'დემოში — პირველი თავი. სრული ლიცენზიით: ნებისმიერი მოცულობის მთელი წიგნი, 300 MB-მდე PDF და DOCX, საერთო წვდომა გუნდისთვის.',
        listTitle: 'რა შედის სრულ ლიცენზიაში:',
        features: [
          'ნებისმიერი მოცულობის წიგნების თარგმანი (1 500+ გვერდი)',
          'ოთხი ეტაპი: თარგმანი, რედაქტირება, კორექტურა, შემოწმება',
          'დასკანერებული PDF-ის ამოცნობა (OCR)',
          'სახელებისა და ტერმინების ლექსიკონი მთელი წიგნისთვის',
          'ინსტალაცია თქვენს სერვერზე ან დახურულ ღრუბელში',
          'თქვენი ხელნაწერები არ გამოიყენება მოდელების გასაწვრთნელად',
        ],
        contactTitle: 'დაგვიკავშირდით ჩართვისა და დემონსტრაციისთვის:',
        back: 'დემო-სტუდიაში დაბრუნება',
      },
    },
  },

  am: {
    code: 'am', flag: '🇦🇲', country: 'Հայաստան', lang: 'hy',
    text: {
      badge: 'Բազմափուլ գրական AI թարգմանություն',
      headline: 'Ձեռագրերը վերածեք պատրաստի գրքերի ցանկացած լեզվով',
      subline: 'Ամբողջական հրատարակչական նախապատրաստում՝ սկանավորված PDF-ների ճանաչումից մինչև քառափուլ խմբագրում՝ պահպանելով հեղինակի ոճը և միասնական տերմինաբանությունը։',
      tagline: 'Գրքերի թարգմանություն, խմբագրում և սրբագրում',
      cta: 'Բացել դեմո-ստուդիան',
      ctaNote: 'Առանց գրանցման — բացվում է անմիջապես',
      books: (n) => `${n} գիրք`,
      sampleTitle: 'Հատվածի օրինակ',
      sampleBadge: 'Փուլ 4: ստուգված է',
      original: 'Բնօրինակ',
      translation: 'Թարգմանություն',
      chapter: 'Գլուխ',
      features: ['Գրքի որակի ստուգում', 'Անունների և տերմինների բառարան', 'Արտահանում DOCX և PDF ձևաչափերով'],
      banner: 'Դեմո ռեժիմ: գրքերի նմուշներ, որոնց առաջին գլուխն իրականում թարգմանված է AI-ով։',
      bannerCta: 'Գնել ամբողջական տարբերակը',
      demoUser: 'Դեմո հյուր',
      upgrade: {
        title: 'FolioFlow Pro լիցենզիա',
        headline: 'Թարգմանեք գրքերն ամբողջությամբ՝ առանց սահմանափակումների',
        sub: 'Դեմոյում՝ առաջին գլուխը։ Ամբողջական լիցենզիայով՝ ցանկացած ծավալի ամբողջ գիրքը, մինչև 300 ՄԲ PDF և DOCX, ընդհանուր հասանելիություն թիմի համար։',
        listTitle: 'Ինչ է ներառված ամբողջական լիցենզիայում:',
        features: [
          'Ցանկացած ծավալի գրքերի թարգմանություն (1 500+ էջ)',
          'Չորս փուլ՝ թարգմանություն, խմբագրում, սրբագրում, ստուգում',
          'Սկանավորված PDF-ների ճանաչում (OCR)',
          'Անունների և տերմինների բառարան ամբողջ գրքի համար',
          'Տեղադրում ձեր սերվերում կամ փակ ամպում',
          'Ձեր ձեռագրերը չեն օգտագործվում մոդելների ուսուցման համար',
        ],
        contactTitle: 'Կապվեք մեզ հետ միացման և ցուցադրման համար:',
        back: 'Վերադառնալ դեմո-ստուդիա',
      },
    },
  },
};

export const DEFAULT_MARKET = 'kg';

/** Ар базардын маалыматы өзүнчө файлда — керек болгондо гана жүктөлөт */
const LOADERS = {
  kg: () => import('./data/kg.js'),
  ru: () => import('./data/ru.js'),
  mn: () => import('./data/mn.js'),
  kz: () => import('./data/kz.js'),
  uz: () => import('./data/uz.js'),
  az: () => import('./data/az.js'),
  ge: () => import('./data/ge.js'),
  am: () => import('./data/am.js'),
};

/**
 * Кирүү бети үчүн чакан маалымат: китептердин саны жана бир үзүндү.
 * Толук маалымат жүздөгөн КБ — кирүү бети аны күтпөшү керек.
 */
const META_LOADERS = {
  kg: () => import('./data/kg.meta.js'),
  ru: () => import('./data/ru.meta.js'),
  mn: () => import('./data/mn.meta.js'),
  kz: () => import('./data/kz.meta.js'),
  uz: () => import('./data/uz.meta.js'),
  az: () => import('./data/az.meta.js'),
  ge: () => import('./data/ge.meta.js'),
  am: () => import('./data/am.meta.js'),
};

const metaCache = new Map();

export async function loadMarketMeta(code) {
  const key = MARKETS[code] ? code : DEFAULT_MARKET;
  if (!metaCache.has(key)) {
    metaCache.set(key, META_LOADERS[key]().catch(() => ({ DEMO_BOOK_COUNT: 0, DEMO_SAMPLE: null })));
  }
  return metaCache.get(key);
}

const EMPTY = Object.freeze({
  DEMO_PROJECTS: [], DEMO_CHAPTERS: [], DEMO_SEGMENTS: [], DEMO_GLOSSARY: [],
});

const cache = new Map();

/**
 * Базардын демо маалыматын жүктөйт. Файл али бош болсо (китептер
 * которула элек) — демо кулабайт, жөн гана китепсиз ачылат.
 */
export async function loadMarketData(code) {
  const key = MARKETS[code] ? code : DEFAULT_MARKET;
  if (!cache.has(key)) {
    cache.set(key, LOADERS[key]().then((m) => ({ ...EMPTY, ...m })).catch(() => EMPTY));
  }
  return cache.get(key);
}

function ruPlural(n, [one, few, many]) {
  const mod10 = n % 10;
  const mod100 = n % 100;
  if (mod10 === 1 && mod100 !== 11) return one;
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return few;
  return many;
}
